import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";

const OilRigIcon = ({ classes, color }) => (
  <svg
    viewBox="0 0 24 24"
    className={classNames(classes.root, classes[color])}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M 11 2 L 11 3 L 10.03125 3 L 9.03125 11 L 14.96875 11 L 13.96875 3 L 13 3 L 13 2 L 11 2 z M 5 12 L 5 14 L 3 14 L 3 16 L 7 16 L 7 17.5625 C 7 17.5625 7.82 18.6725 9 18.9375 L 9 16 L 15 16 L 15 18.9375 C 16.18 18.6725 17 17.5625 17 17.5625 L 17 16 L 21 16 L 21 14 L 19 14 L 19 12 L 5 12 z M 2 19 L 2 21 C 2.739 21.754 3.806 22 4.5 22 C 5.194 22 6.261 21.754 7 21 C 7.739 21.754 8.806 22 9.5 22 C 10.194 22 11.261 21.754 12 21 C 12.739 21.754 13.806 22 14.5 22 C 15.194 22 16.261 21.754 17 21 C 17.739 21.754 18.806 22 19.5 22 C 20.194 22 21.261 21.754 22 21 L 22 19 C 21.261 19.754 20.194 20 19.5 20 C 18.806 20 17.739 19.754 17 19 C 16.261 19.754 15.194 20 14.5 20 C 13.806 20 12.739 19.754 12 19 C 11.261 19.754 10.194 20 9.5 20 C 8.806 20 7.739 19.754 7 19 C 6.261 19.754 5.194 20 4.5 20 C 3.806 20 2.739 19.754 2 19 z" />
  </svg>
);

const styles = theme => ({
  root: {
    fill: theme.palette.secondary.main,
  },
  primary: {
    fill: theme.palette.primary.main,
  },
});

export default withStyles(styles)(OilRigIcon);
